import { SubscriptionKind } from "./SubscriptionKind";
import { Plan } from "../Plan";
import { Status } from "./Status";

export enum SubscriptionUserInfoNewsletter {
  SUBSCRIBED = "subscribed",
  REJECTED = "rejected",
  ASK = "ask",
  SKIP = "skip",
}

export enum SubscriptionUserInfoOver18 {
  CONFIRMED = "confirmed",
}

export enum SubscriptionUserInfoPref {
  EMAIL = "email",
  SMS = "sms",
}

export interface SubscriptionUserInfo {
  termsUrl?: string;
  termsName?: string;
  over18?: SubscriptionUserInfoOver18;
  newsletter?: SubscriptionUserInfoNewsletter;
  pref?: SubscriptionUserInfoPref;
  email?: string;
  msisdn?: string;
}

export interface Subscription {
  kind: SubscriptionKind;
  plan: Plan;
  status: Status;
  cancelAtPeriodEnd: boolean;
  activeUntil: string;
  id: string;
  userInfo?: SubscriptionUserInfo;
  customData?: Partial<StripeCustomData> | Record<string, string>;
}

export interface StripeCustomData {
  stripe_email: string;
  stripe_customer_id: string;
}
